const LiveBadge = () => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
    <span
      style={{
        display: "inline-block",
        width: 8,
        height: 8,
        borderRadius: "50%",
        backgroundColor: "#00c446",
      }}
    />
    Live
  </span>
)

export const MatchLiveStatusMap = (data) => {
    if (!data.status) return "TBD"

    switch (data.status) {
      case "live":
        return <LiveBadge />
      case "walk over":
        return "Walk over"
      case "completed":
      case "end":
        return data.isWO ? "Walkover" : "Completed"
      case "not before":
        return `Not before ${data.date || ''} ${data.hour || ''}`
      default:
        return "TBD"
    }
}